import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/core/service/common-service/common.service';

@Component({
  selector: 'app-prs-complaint-dialog',
  templateUrl: './prs-complaint-dialog.component.html',
  styleUrls: ['./prs-complaint-dialog.component.css']
})
export class PrsComplaintDialogComponent implements OnInit {

  category1: string;
  category2: string;
  category3: string = '';
  vehicleType: string = '';
  preferredLanguage: string;
  customerId: string = '';
  chassisNo: string = '';
  vehRegNo: string = '';
  dealerCode: string = '';
  source: string = '';
  complaintRemarks: string;
  additionalRemarks: string = '';
  category1Array: { key: any, value: any }[] = [];
  category2Array: { key: any, value: any }[] = [];
  roleId: string;
  sourceArray: { key: any, value: any }[] = []
  data1: {}
  complaintId: string = "";
  isSubmitted: boolean = false;
  callType: string;
  selectedSource: string = "PRS";
  vehicleRegNo: string = "";
  selectedCategory1: string;
  selectedCategory2: string;
  closureRemarks: string = '';
  initialRemarks: string = '';
  jobCardNo: string = '';
  customerID: string;
  callTypeCode: any;
  customerData: any;
  userId: string;
  checkRem: boolean = true;
  checkDes: boolean = true;

  constructor(
    private dialogRef: MatDialogRef<PrsComplaintDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService, private commonService: CommonService
  ) {
    this.dealerCode = data.dealerCode;
    this.customerId = data.customerId;
    this.chassisNo = data.chassis;
    this.jobCardNo = data.jobCardNo;
    if (data.vehicleRegNo != null) {
      this.vehRegNo = data.vehicleRegNo;
      this.vehicleRegNo = data.vehicleRegNo;
    } else {
      this.vehRegNo = '';
    }

  }

  ngOnInit() {
    this.roleId = localStorage.getItem('roleId');
    this.userId = localStorage.getItem("userId");
    this.customerData = JSON.parse(localStorage.getItem("customerData")) || {};

    this.callTypeCode = this.customerData.callTypeSq;
    this.customerID = localStorage.getItem("customerId");
    if (this.roleId == "12") {
      this.selectedSource = "Z04"
    }

    if (this.roleId == "1") {
      this.category1Array.push({ "key": "02", "value": "AM-Dealer" })
      this.sourceArray.push({ "key": 'Z09', "value": "Iconnect" });
      this.selectedCategory1 = "02";
    }
    else {
      this.category1Array.push({ "key": "01", "value": "Sales" }, { "key": "02", "value": "AM-Dealer" })
      this.sourceArray.push({ "key": 'Z04', "value": "PRS" }, { "key": 'Z06', "value": "1st Month Survey" }, { "key": 'Z07', "value": "4th Month Survey" }, { "key": 'Z08', "value": "9th Month Survey" })
    }

    if (this.roleId == "1") {
      this.category2Array.push({ "key": "Z9", "value": "Iconnect" });
      this.selectedCategory2 = "Z9";
    }

    this.callType = localStorage.getItem("selectedCallTypeValues");
    this.getSource();
  }

  getSource() {
    if (this.roleId == '12') {
      if (this.callType == "1st Month - Sales Experience")
        this.selectedSource = "Z06"

      if (this.callType == "4th Month - Product Experience")
        this.selectedSource = "Z07"

      if (this.callType == "9th Month - Service Experience")
        this.selectedSource = "Z08"

      if (this.callType == "PRS-Post Repair Survey")
        this.selectedSource = "Z04"
    }

    if (this.roleId == '1') {
      this.selectedSource = "Z09";
    }
  }

  categorySelected() {

    // if (this.category1 == 'Sales') {
    //   this.category2Array.push({"key":"Delivery", "value":"Delivery"},{"key":"Sales", "value":"Sales"},{"key":"PreSales", "value":"Pre-Sales"});
    // }
    if (this.roleId == "1") {
      if (this.selectedCategory1 == '02') {
        this.category2Array.push({ "key": "Z9", "value": "Iconnect" }
          // ,{"key": "ProductSafety", "value":'Product Safety'},{"key": "Spares", "value": "Spares"},{"key": "LowFeedbackConcern", "value": "Low Feedback Concern"}, {"key":"ServiceQuality","value":"Service Quality"},{"key":"ProductPerformance","value": "Product Performance"},{"key": "EOSVehicleBreakdown","value":'EOS-Vehicle Breakdown'}, {"key":"InstantFeedback","value":'Instant Feedback'},{"key":"NPS","value": 'NPS'}
        );
      } else {
        this.category2Array.push({ "key": "PleaseSelectCategory1", "value": 'Please Select Category 1' });
      }
    }
    else {
      if (this.selectedCategory1 == "01") {
        this.category2Array.push({ "key": "02", "value": "Delivery" }, { "key": "03", "value": "Sales" }, { "key": "04", "value": "Pre-Sales" });
      }
      else if (this.selectedCategory1 == "02") {
        this.category2Array.push({ "key": "13", "value": 'Product Safety' }, { "key": "14", "value": "Spares" }, { "key": "43", "value": "Low Feedback Concern" }, { "key": "06", "value": "Service Quality" }, { "key": "07", "value": "Product Performance" }, { "key": "27", "value": 'EOS-Vehicle Breakdown' }, { "key": "26", "value": 'Instant Feedback' }, { "key": "28", "value": 'NPS' })
      }
      else {
        this.category2Array.push({ "key": "PleaseSelectCategory1", "value": 'Please Select Category 1' });
      }

    }
  }

  onClose() {
    this.dialogRef.close(this.complaintId);
  }

  createComplaint() {
    if (this.selectedCategory1 == null || this.selectedCategory2 == null || this.preferredLanguage == null || (this.initialRemarks == null || this.initialRemarks == '') || (this.closureRemarks == null || this.closureRemarks == '')) {
      this.toastr.error("Please fill required fields");
    } else {
      this.commonService.saveComplaintDialog(this.customerId, this.preferredLanguage, this.vehicleRegNo, this.vehicleType, this.chassisNo, this.dealerCode, this.initialRemarks, this.selectedCategory1, this.selectedCategory2, this.category3, this.selectedSource, this.closureRemarks).subscribe(res => {
        if (res["responseCode"] == 0 && res["responseData"].complaintId != "") {
          this.data1 = {
            complaintId: res["responseData"].complaintId,
            isSubmitted: false,
            complaintRemarks: this.closureRemarks
          }
          this.commonService.saveComplaint(this.jobCardNo, this.roleId, this.userId, this.callTypeCode, res["responseData"].complaintId, this.customerID, this.chassisNo).subscribe();
          this.commonService.complainUpdateCallList(this.customerId, this.chassisNo, this.jobCardNo, this.callTypeCode, this.userId, this.roleId).subscribe();
          this.complaintId = res["responseData"].complaintId;
          this.toastr.info("Complaint Submitted of ID " + res["responseData"].complaintId);
          this.dialogRef.close(this.data1);
        }
        else {
          this.toastr.error(res["responseData"].messageTxt, "Error");
          this.dialogRef.close();
        }
      }, error => {
        this.toastr.error("Something went wrong, Please try again.", "Error");
        this.dialogRef.close();
      });
    }
  }

  omit_special_charDes(e) {
    console.log(e.target.id);
    var k;
    document.all ? k = e.keyCode : k = e.which;
    this.checkDes = ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    console.log(this.checkRem, this.checkDes)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_special_charRem(e) {
    console.log(e.target.id);
    var k;
    document.all ? k = e.keyCode : k = e.which;
    this.checkRem = ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    console.log(this.checkRem, this.checkDes)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

}

export function openPrsComplaintDialog(dialog: MatDialog, dealerCode: any, customerId: any, chassis: any, vehicleRegNo: any, jobCardNo: any, callTypeCode: any, roleId: any) {
  const config = new MatDialogConfig();
  config.disableClose = true;
  config.autoFocus = true;
  config.width = '850px';
  config.height = '530px';
  config.data = {
    vehicleRegNo: vehicleRegNo,
    dealerCode: dealerCode,
    customerId: customerId,
    chassis: chassis,
    jobCardNo: jobCardNo,
    callTypeCode: callTypeCode,
    roleId: roleId
  };
  const dialogRef = dialog.open(PrsComplaintDialogComponent, config);
  return dialogRef.afterClosed();
}